// extracted by mini-css-extract-plugin
export default {"priceType":"pricetype_priceType__Kc6wk","price":"pricetype_price__nPBig"};